export const firebaseConfig = {
  apiKey: "AIzaSyDfi9SMu_n1G-APWwQzzrukLzz5SE8nXD4",
  authDomain: "gestaoparceiros-homologacao.firebaseapp.com",
  projectId: "gestaoparceiros-homologacao",
  storageBucket: "gestaoparceiros-homologacao.firebasestorage.app",
  messagingSenderId: "1061886084376",
  appId: "1:1061886084376:web:f888727734477b3517ca6d"
};